import * as yup from 'yup';
import {
  OriginFormValue,
  BotflowFormValue,
  ORIGIN_VALUES,
  COMMERCIAL_VALUES,
  CLUSTER_VALUES,
  CommercialFormValue,
} from '.';

// Origin - campo obrigatório do motivo do atendimento
const originSchema = yup
  .string()
  .oneOf(
    Object.values(ORIGIN_VALUES),
    'Erro ao selecionar o motivo do atendimento'
  )
  .required('Selecione o motivo do atendimento')
  .transform((value): OriginFormValue => value as OriginFormValue);

const orderSchema = yup.object().shape({
  name: yup.string().required('Adicione o nome do pedido'),
  value: yup
    .number()
    .typeError('Adicione o valor do pedido')
    .integer('Adicione o valor do pedido')
    .positive('Adicione o valor do pedido')
    .required('Adicione o valor do pedido'),
  payment: yup.string().required('Escolha o método de pagamento'),
  status: yup.string().required('Escolha o status do pedido'),
  sales_status: yup.string().required('Escolha o tipo de venda'),
});

const botflowSchema = yup
  .object()
  .shape({
    flow_id: yup.string().required('Selecione o fluxo do bot'),
  })
  .transform((value): BotflowFormValue | null => {
    if (!value || Object.keys(value).length === 0) return null;
    return value as BotflowFormValue;
  });

const commercialSchema = yup.object().shape({
  type: yup.string().required('error commercial type'),
  order: yup.object().when('type', {
    is: COMMERCIAL_VALUES.sale_completed,
    then: orderSchema,
    otherwise: yup.object().notRequired(),
  }),
});

const ORIGIN_SCHEMA_VALUE = 'origin';
export const formSchema = yup.object().shape({
  cluster: yup.string().notRequired(),
  origin: originSchema,
  support: yup.string().when(ORIGIN_SCHEMA_VALUE, {
    is: ORIGIN_VALUES.support,
    then: yup.string().required('Escolha o tipo do atendimento'),
    otherwise: yup.string().notRequired(),
  }),
  financial: yup.string().when(ORIGIN_SCHEMA_VALUE, {
    is: ORIGIN_VALUES.financial,
    then: yup.string().required('Escolha o tipo do atendimento'),
    otherwise: yup.string().notRequired(),
  }),
  others: yup.string().when(ORIGIN_SCHEMA_VALUE, {
    is: ORIGIN_VALUES.other,
    then: yup.string().nullable().optional(),
    otherwise: yup.string().notRequired(),
  }),
  commercial: yup.object().when(ORIGIN_SCHEMA_VALUE, {
    is: ORIGIN_VALUES.commercial,
    then: commercialSchema,
    otherwise: yup.object().notRequired(),
  }),
  // validação do botflow quando o cluster é ativo e o motivo do atendimento é comercial
  botflow: yup
    .object()
    .when([ORIGIN_SCHEMA_VALUE, 'cluster', 'commercial.type'], {
      is: (
        origin: OriginFormValue,
        cluster: string,
        commercialType: CommercialFormValue
      ) =>
        origin === ORIGIN_VALUES.commercial &&
        cluster === CLUSTER_VALUES['active'] &&
        commercialType !== COMMERCIAL_VALUES.other,
      then: botflowSchema,
      otherwise: yup.object().nullable().notRequired(),
    }),
});

export type FinishChatFormValue = yup.InferType<typeof formSchema>;
